import { Spinner } from "@heroui/react";
import { type AdminProductionProgress, PRODUCTION_STATE_LABELS } from "@storyline/shared";
import CostProgressBanner from "@/src/stories/components/cost-progress-banner";

type GeneratingProgressProps = {
	production: AdminProductionProgress;
};

const GeneratingProgress: React.FC<GeneratingProgressProps> = ({ production }) => (
	<div className="flex flex-col gap-4">
		<div className="flex items-center gap-3 rounded-xl border border-border-soft bg-surface p-5">
			<Spinner size="sm" />
			<div className="flex flex-col">
				<span className="font-semibold text-foreground">{PRODUCTION_STATE_LABELS[production.productionState]}</span>
				<span className="text-muted text-sm">
					La génération tourne en tâche de fond. L'étape avance automatiquement une fois tous les jobs terminés.
				</span>
			</div>
		</div>
		<CostProgressBanner production={production} />
	</div>
);

export default GeneratingProgress;
